import 'css-chunksrc/client/common/filterMenu/loader/styles.scss';export default {
  "loader": "_loader_bnft7_1",
  "item": "_item_bnft7_5",
  "checkbox": "_checkbox_bnft7_15",
  "name": "_name_bnft7_23"
};